<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 


<!-- CHECK IF NOT SCHEDULED -->
<div v-if="data_dates.length == 0" class="columns is-gapless is-multiline" style="margin-bottom:-2.5em;">
<div class="column is-12 has-text-centered is-size-3 has-text-weight-bold has-background-danger has-text-white">COURSE NOT SCHEDULED</div>
<div class="column is-12 has-text-centered is-size-7 has-text-weight-bold has-background-danger has-text-white is-italic">Course must be scheduled to enter lates/absences</div>

</div>



<table class="table">
  <thead>
    <tr>
        <th> &nbsp; </th>
        <th v-for ="(info, index) in data_dates" :key="index">
            <div class="columns is-gapless is-multiline">
                <div class="column is-12 has-text-centered">{{moment(info.schedMain_date).format('MMM')}}</div>
                <div class="column is-12 has-text-centered">{{moment(info.schedMain_date).format('DD')}}</div>
            </div>
        </th>
    </tr>
  </thead>
  <tbody>
    <tr v-for ="(info, indexRow) in data_students" :key="indexRow">
        <td>  

            <div class="columns is-gapless is-multiline">
                <div class="column is-12 has-text-weight-bold">{{info.student_lNAME}}</div>
                <div class="column is-12 is-size-7" style="margin-top:-.8em;">{{info.student_fNAME}}</div>
            </div>

        </td>
        <td v-for ="(info, index) in data_dates" :key="index"> <a class="button is-small is-fullwidth has-background-success-light">
            <span class="icon is-small"><i class="fas fa-check-circle"></i></span>
        </a> </td>
    </tr>
  </tbody>
</table>


</div>
</template>



<script>
import axios from 'axios';
import moment from 'moment';

export default {
        props: [ 'group_id' ],
        components: {  },

        data() {
            return {
                 isLoading:false,

data_dates:[],
data_students:[],


            }
        },

created() {


if (this.group_id=='') {return}

    this.isLoading=true;
    // CHECK IF SCHEDULE DEFINED -- IF NOT : NO
    var query = `SELECT * FROM myMEQ_SCHEDULE_MAIN WHERE group_ID = ` + this.group_id
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.data_dates = res.data


    query=`SELECT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME,MyMEQ_STUDENT.student_fNAME,student_GRPCODE FROM  MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID  
    WHERE  (MyMEQ_COURSESTUDENT.group_ID = ` + this.group_id + `) ORDER BY student_lNAME`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_students = res.data
        this.isLoading=false;

    });    });

 

},


methods: {


}, // END METHODS



} // END EXPORT
</script>




<style scoped>

select {
  text-align: center;
  text-align-last: center;
  font-weight: 900;
  /* webkit*/
}
option {
  text-align: left;
  /* reset to left*/
}

</style>